import _ from "lodash";
import { QUEUE_CONFIG } from '../actions/types';
import { constants } from '../Constants/constants';

const INITIAL_STATE = {
    ui: {
        queueConfig: _.cloneDeep(constants.QUEUE_CONFIG_INPUT)
    }
}

const queueConfigReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case QUEUE_CONFIG.SET_QUEUE_CONFIG_DEFAULT:
            return Object.assign({}, INITIAL_STATE)
        case QUEUE_CONFIG.SET_QUEUE_CONFIG:
        case QUEUE_CONFIG.SET_QUEUE_CONFIG_VALUE:
            return Object.assign({}, {
                ...state,
                ui: {
                    ...state.ui,
                    queueConfig: action.queueConfig
                }
            })
        default:
            return state
    }
}

export default queueConfigReducer